import { render, staticRenderFns } from "./startseite-projektmanagement-4.vue?vue&type=template&id=49767c4c&"
import script from "./startseite-projektmanagement-4.vue?vue&type=script&lang=js&"
export * from "./startseite-projektmanagement-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports